import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-errorpage',
  templateUrl: './errorpage.component.html',
  styleUrls: ['./errorpage.component.scss'],
  standalone: false,
})
export class ErrorpageComponent implements OnInit {
  constructor(public location: Location) {}

  ngOnInit(): void {}
}
